<template>
  <div class="staked-nfts">
    <div class="d-flex flex-row justify-content-center staked-header">
      STAKED
    </div>
    <div class="d-flex flex-row justify-content-center position-relative barn">
      <div class="left-arrow">
        <button
          class="pagination-minus-staked-comp"
          v-if="stakedNftsChicken.length > 1"
          @click="decreasePage('chicken', chickenIndex, stakedNftsChicken)"
        >
          &lt;
        </button>
      </div>
      <img
        class="barn-image"
        src="../assets/images/chicken-coop-new.webp"
        alt=""
      />
      <div
        class="nft-button windows-command-prompt"
        style="margin-top: -3px"
      > 
        <img v-if="chickensLoading" class="loading-gif" src="../assets/images/gifs/loading-fast.gif" alt="">
        <button
          v-else-if="stakedNftsChicken.length > 0"
          v-for="nft in stakedNftsChicken[chickenIndex].pageInside[0]"
          :key="nft.id"
          @click="stakedNftClicked(nft)"
          :class="choosenNfts.find((p) => p.id == nft.id) ? 'choosen-ones' : ''"
        >
          <img
            class="nft-button-image"
            :src="nft.nftDetail.nft"
            :alt="nft.nftDetail.name"
          />
          <span>{{ nft.nftDetail.eggs }}</span>
        </button>
      </div>

      <div class="right-arrow">
        <button
          class="pagination-plus-staked-comp"
          v-if="stakedNftsChicken.length > 1"
          @click="increasePage('chicken', chickenIndex, stakedNftsChicken)"
        >
          &gt;
        </button>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center bar-name">
      <span>CHICKENS COOP</span>
    </div>
    <div class="d-flex flex-row justify-content-center position-relative barn">
      <div class="left-arrow">
        <button
          class="pagination-minus-staked-comp"
          v-if="stakedNftsSnake.length > 1"
          @click="decreasePage('snake', snakeIndex, stakedNftsSnake)"
        >
          &lt;
        </button>
      </div>
      <img
        class="barn-image"
        src="../assets/images/snake-bar-new.webp"
        alt=""
      />
      <div
        class="nft-button windows-command-prompt"
        style="margin-top: -3px"
      >
        <img v-if="snakesLoading" class="loading-gif" src="../assets/images/gifs/loading-fast.gif" alt="">
        <button
          v-else-if="stakedNftsSnake.length > 0"
          v-for="nft in stakedNftsSnake[snakeIndex].pageInside[0]"
          :key="nft.id"
          @click="stakedNftClicked(nft)"
          :class="choosenNfts.find((p) => p.id == nft.id) ? 'choosen-ones' : ''"
        >
          <img
            class="nft-button-image"
            :src="nft.nftDetail.nft"
            :alt="nft.nftDetail.name"
          />
          <span>{{ nft.nftDetail.eggs }}</span>
        </button>
      </div>
      <div class="right-arrow">
        <button
          class="pagination-plus-staked-comp"
          v-if="stakedNftsSnake.length > 1"
          @click="increasePage('snake', snakeIndex, stakedNftsSnake)"
        >
          &gt;
        </button>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center bar-name">
      <span>SNAKES CAVE</span>
    </div>
    <div class="d-flex flex-row justify-content-center position-relative barn">
      <div class="left-arrow">
        <button
          class="pagination-minus-staked-comp"
          v-if="stakedNftsRooster.length > 1 && !roostersLoading"
          @click="decreasePage('rooster', roosterIndex, stakedNftsRooster)"
        >
          &lt;
        </button>
      </div>
      <img
        class="barn-image"
        src="../assets/images/rooster-bar-new.webp"
        alt=""
      />
      <div
        class="nft-button windows-command-prompt"
        style="margin-top: -3px"
      >
        <img v-if="roostersLoading" class="loading-gif" src="../assets/images/gifs/loading-fast.gif" alt="">
        <button
          v-else-if="stakedNftsRooster.length > 0"
          v-for="nft in stakedNftsRooster[roosterIndex].pageInside[0]"
          :key="nft.id"
          @click="stakedNftClicked(nft)"
          :class="choosenNfts.find((p) => p.id == nft.id) ? 'choosen-ones' : ''"
        >
          <img
            class="nft-button-image"
            :src="nft.nftDetail.nft"
            :alt="nft.nftDetail.name"
          />
          <span>{{ nft.nftDetail.eggs }}</span>
        </button>
      </div>
      <div class="right-arrow">
        <button
          class="pagination-plus-staked-comp"
          v-if="stakedNftsRooster.length > 1"
          @click="increasePage('rooster', roosterIndex, stakedNftsRooster)"
        >
          &gt;
        </button>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center bar-name">
      <span>ROOSTERS LAIR</span>
    </div>
    <div class="d-flex flex-row justify-content-center mt-3 unclaimed-reward">
      <span
        >UNCLAIMED REWARD :
        <img src="../assets/images/eggtoken-2.webp" alt="" />
        {{ unclaimedReward }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "choosenNfts",
    "stakedNftsWithoutPagination",
    "stakedNftsChicken",
    "stakedNftsRooster",
    "stakedNftsSnake",
    "snakesLoading",
    "chickensLoading",
    "roostersLoading",
  ],
  data() {
    return {
      snakeIndex: 0,
      chickenIndex: 0,
      roosterIndex: 0,
    };
  },
  computed: {
    unclaimedReward() {
      let eggs = 0;
      for (let i = 0; i < this.stakedNftsWithoutPagination.length; i++) {
        eggs += parseFloat(this.stakedNftsWithoutPagination[i].nftDetail.eggs)
      }
      return parseFloat(eggs).toFixed(2);
    },
  },
  methods: {
    decreasePage(whichIndex, index, pagination) {
      if (pagination.length > 1 && index > 0) {
        index--;
        switch (whichIndex) {
          case "chicken":
            this.chickenIndex = index;
            break;
          case "rooster":
            this.roosterIndex = index;
            break;
          case "snake":
            this.snakeIndex = index;
            break;
        }
      }
    },
    increasePage(whichIndex, index, pagination) {
      if (index < pagination.length - 1) {
        index++;
        switch (whichIndex) {
          case "chicken":
            this.chickenIndex = index;
            break;
          case "rooster":
            this.roosterIndex = index;
            break;
          case "snake":
            this.snakeIndex = index;
            break;
        }
      }
    },
    stakedNftClicked(nft) {
      this.$emit("stakedNFTClicked", nft);
    },
  }
};
</script>

<style scoped>
.staked-nfts {
  background-image: url("../assets/images/staked-new-parchment.webp");
  background-repeat: no-repeat;
  background-size: 507px 481px;
  width: 507px;
  height: 481px;
  margin: 27px auto;
}
.staked-header {
  font-size: 48px;
  color: #000;
  line-height: 30px;
  padding: 35px 0 0 0;
}
.loading-gif{
  height: 70px;
}
.bar-name {
  font-size: 20px;
  color: #000;
  margin-top: -5px;
}
.unclaimed-reward {
  font-size: 25px;
  color: #000;
}
.choosen-ones {
  border: 3px solid #ffd83a !important;
}
.nft-button {
  position: absolute;
  bottom: 0;
}
.nft-button-image {
  width: 60px;
  height: 60px;
  z-index: 9999;
}
.nft-button button {
  padding: 0;
  background: none;
  border: 3px solid transparent;
  margin: 0 7px;
  position: relative;
}
.pagination-minus-staked-comp{
  color: black;
  position: absolute;
  left: 20px;
}
.pagination-plus-staked-comp{
  color: black;
  position: absolute;
  right: 20px;
}
.nft-button span {
  position: absolute;
  background: #6c0000;
  color: white;
  left: 0;
  right: 0;
  margin: auto;
  bottom: -3px;
  width: 48px;
  height: 14px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  font-weight: bold;
}
.barn {
  margin-top: 35px;
}
.left-arrow button{
  background:none;
  border:none;
  font-size: 30px;
}
.right-arrow button{
  background:none;
  border:none;
  font-size: 30px;
}
@media (max-width: 1300px) {
  .staked-nfts {
    background-size: 400px 320px;
    width: 400px;
    height: 320px;
    margin: 27px auto;
  }
  .nft-button-image {
    width: 42px;
    height: 42px;
  }
  .nft-button span {
    height: 10px;
    line-height: 10px;
    font-size: 10px;
    width: 35px;
    text-align: center;
  }
  .loading-gif{
    height: 55px;
  }
  .barn {
    margin-top: 15px;
  }
  .bar-name {
    font-size: 15px;
  }
  .staked-header {
    font-size: 32px;
    color: #000;
    padding: 15px 0 0 0;
  }
  .barn-image {
    width: 290px;
  }
  .unclaimed-reward {
    font-size: 20px;
  }
}
@media (max-width: 769px) {
  .staked-nfts {
    background-size: 298px 300px;
    width: 298px;
    height: 300px;
    margin: 27px auto;
  }
  .barn {
    margin-top: 15px;
  }
  .bar-name {
    font-size: 15px;
  }
  .nft-button-image {
    width: 40px;
    height: 40px;
  }
  .nft-button span {
    height: 8.5px;
    line-height: 8.5px;
    font-size: 8.5px;
  }
  .staked-header {
    font-size: 32px;
    color: #000;
    padding: 18px 0 0 0;
  }
  .barn-image {
    width: 240px;
  }
  .unclaimed-reward {
    font-size: 15px;
  }
  .loading-gif{
    height: 45px;
  }
  .pagination-plus-staked-comp{
    right: 5px;
    bottom: -5px;
  }
  .pagination-minus-staked-comp{
    left: 5px;
    bottom: -5px
  }
  @supports (-webkit-touch-callout: none) {
        .pagination-plus-staked-comp{
          right: -20px;
          bottom: -10px;
        }
        .pagination-minus-staked-comp{
          left: -20px;
          bottom: -10px
        }
    }
}
</style>